import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * L'en-tête commun à toutes les pages de paramétrage.
 *
 * Il existe en composant plutôt qu'en bout de code à recopier parce que c'est
 * la recopie qui a produit l'écart : quatorze pages, cinq tailles de titre,
 * deux familles de gris, six flèches écrites en caractère plutôt qu'en icône,
 * et quatre pages qui avaient tout bonnement oublié le bouton de retour.
 *
 * Plusieurs pages le dupliquaient même à l'intérieur d'un seul fichier — une
 * fois pour l'écran de chargement, une fois pour l'écran normal — et les deux
 * copies avaient déjà commencé à diverger.
 *
 * La norme : PARAMETRAGE-MODULES.md §1.
 *
 * ----------------------------------------------------------------------------
 * Pas de pastille d'icône
 * ----------------------------------------------------------------------------
 * Elle a existé, puis elle est partie : le titre dit déjà quel module on règle,
 * et l'icône ne faisait que répéter ce que le tableau de bord venait d'afficher
 * sur la carte qu'on a cliquée. DESIGN-SYSTEM.md le dit pour toute
 * l'application — les icônes sont fonctionnelles, pas décoratives.
 *
 * `icone` reste accepté pour ne pas casser les quinze appels existants ; il est
 * simplement ignoré.
 *
 * @param onRetour    ce que fait le bouton Retour. Sans lui, la page est un
 *                    cul-de-sac : le bouton s'affiche désactivé plutôt que de
 *                    laisser croire qu'il mène quelque part.
 * @param titre       « Paramétrage de… », pour distinguer du module lui-même.
 * @param sousTitre   ce que la page contient, pas ce que le module fait.
 * @param actions     boutons alignés à droite (rafraîchir, basculer une vue).
 */
const EnTeteParametrage = ({ onRetour, titre, sousTitre, actions }) => (
  <div className="mb-6">
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div className="flex items-center gap-4">
        <Button
          onClick={onRetour}
          disabled={!onRetour}
          variant="outline"
          size="sm"
          className="border-gray-200 text-gray-500 hover:bg-[#246990] hover:text-white hover:border-[#246990] transition-all"
        >
          <ArrowLeft size={15} className="mr-1.5" /> Retour
        </Button>

        <div className="h-8 w-px bg-gray-200" />

        <div>
          <h1 className="text-lg font-bold text-gray-900">{titre}</h1>
          {sousTitre && <p className="text-xs text-gray-500 mt-0.5">{sousTitre}</p>}
        </div>
      </div>

      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  </div>
);

export default EnTeteParametrage;
